import {MaybePromise} from '@coolcolduk/typescript-util';
import getFirebaseToken from './getFirebaseToken';

export default async function withFirebaseToken<T>(fn: (token?: string) => MaybePromise<T>) {
  return fn(await getFirebaseToken());
}
